// flex flex-col gap-2

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const sidebar = css`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  position: absolute;
  bottom: 1em;
  right: 0.5em;
  z-index: 40;
  font-size: 12px;
  @container feed (width > 200px) {
    font-size: 16px;
  }
`;

export const likeIcon = css`
  background-image: linear-gradient(45deg, ${theme.colors.peoople['azul-claro-medio']} 0%, ${theme.colors.peoople['azul-electrico']} 100%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const like = css`
  &:hover .${likeIcon} {
    background-image: linear-gradient(135deg, ${theme.colors.peoople['azul-claro-medio']} 0%, ${theme.colors.peoople['azul-electrico']} 100%);
  }
`;

export const animateLike = css`
  @keyframes like {
    0% {
      transform: scale(0.25);
    }
    100% {
      transform: scale(1);
    }
  }
  animation: like 0.125s ease-in;
`;

export const btnsText = css`
  font-size: 0.9em;
  font-weight: 600;
  text-align: center;
`;
